/* 3rdBall — storefront interactions
   Progressive enhancement: every feature degrades to a usable static page. */
(function () {
  'use strict';
  document.documentElement.classList.remove('no-js');

  /* Interface strings. The Lithuanian pages set <html lang="lt">; everything else reads English. */
  var STRINGS = {
    en: {
      soldOut: 'Sold out', addToCart: 'Add to cart', added: 'Added',
      optionOut: 'This option is sold out. The options that are not crossed out are in stock.',
      allOut: 'Sold out. Email help@3rdball.eu and we will tell you when it is back.',
      only1: 'Only 1 left', inStock: 'In stock',
      dispatch: ' \u2014 dispatched from Lithuania within one working day. Tracked delivery: 1\u20133 working days in the Baltics, up to 10 across the rest of the EU.',
      item: 'item', addedToCart: ' added to cart. Cart now has ', items: ' items.', oneItem: ' item.',
      count: function (n) { return n + (n === 1 ? ' product' : ' products'); },
      matchFilters: function (n) { return n + ' products match the current filters.'; },
      sortedBy: function (t) { return 'Sorted by ' + t + '.'; },
      newsletter: 'Thanks \u2014 prototype only, nothing was sent.',
      cartError: 'Could not add that to the cart. Please try again.'
    },
    lt: {
      soldOut: 'I\u0161parduota', addToCart: '\u012E krep\u0161el\u012F', added: 'Prid\u0117ta',
      optionOut: '\u0160is variantas i\u0161parduotas. Neperbraukti variantai yra sand\u0117lyje.',
      allOut: 'I\u0161parduota. Para\u0161ykite help@3rdball.eu ir prane\u0161ime, kai tur\u0117sime.',
      only1: 'Liko tik 1', inStock: 'Sand\u0117lyje',
      dispatch: ' \u2014 i\u0161siun\u010Diame i\u0161 Lietuvos per vien\u0105 darbo dien\u0105. Sekamas pristatymas: Baltijos \u0161alyse per 1\u20133 darbo dienas, kitose ES \u0161alyse \u2013 iki 10.',
      item: 'prek\u0117', addedToCart: ' prid\u0117ta \u012F krep\u0161el\u012F. Krep\u0161elyje i\u0161 viso: ',
      items: ' vnt.', oneItem: ' vnt.',
      /* 1 prek\u0117, 2-9 prek\u0117s, 10-20 preki\u0173, 21 prek\u0117 ... */
      word: function (n) {
        var t = n % 10, h = n % 100;
        if (t === 1 && h !== 11) return 'prek\u0117';
        if (t >= 2 && t <= 9 && (h < 11 || h > 19)) return 'prek\u0117s';
        return 'preki\u0173';
      },
      count: function (n) { return n + ' ' + this.word(n); },
      matchFilters: function (n) { return n + ' ' + this.word(n) + ' atitinka filtrus.'; },
      sortedBy: function (t) { return 'Rikiuojama: ' + t + '.'; },
      newsletter: 'A\u010Di\u016B \u2014 tai tik prototipas, niekas nebuvo i\u0161si\u0173sta.',
      cartError: 'Nepavyko \u012Fd\u0117ti \u012F krep\u0161el\u012F. Bandykite dar kart\u0105.'
    }
  };
  /* Strings for the language of the part of the page doing the writing: <html lang> on the real
     site. In the one-file preview every route carries its own lang, so an English and a
     Lithuanian product page can live in the same document and each speaks its own language. */
  function strings(el) {
    var host = el && el.closest ? el.closest('[lang]') : null;
    return STRINGS[(host || document.documentElement).getAttribute('lang') === 'lt' ? 'lt' : 'en'];
  }

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------- Scroll reveal ----------
     Sections fade and rise as they come into view. IntersectionObserver drives it,
     but a scroll fallback runs alongside: an observer only fires while the document
     is actually being rendered, and content must never be left stuck at opacity 0. */
  window.revealInView = function () {};
  (function reveal() {
    var els = $$('[data-reveal]');
    if (!els.length) return;

    if (reduced.matches) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }

    function show(el) { el.classList.add('is-in'); }

    // reveal anything already on screen, without waiting on the observer
    function sweep() {
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var pending = false;
      els.forEach(function (el) {
        if (el.classList.contains('is-in')) return;
        var r = el.getBoundingClientRect();
        // Anything whose top has crossed the trigger line counts as seen - including
        // content already scrolled past, which a jump or an anchor link skips over.
        if (r.height > 0 && r.top < vh * 0.92) show(el);
        else pending = true;
      });
      return pending;
    }
    window.revealInView = sweep;

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { show(e.target); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
      els.forEach(function (el) { io.observe(el); });
    }

    // Timer-throttled rather than rAF-throttled: rAF is suspended in documents
    // that are not being painted, and the fallback has to work exactly then.
    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      setTimeout(function () { ticking = false; sweep(); }, 16);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });

    // The first sweep can run before layout, when every rect is still 0x0 and
    // nothing measures as on-screen. Sweep again once layout and load have settled.
    sweep();
    setTimeout(sweep, 0);
    setTimeout(sweep, 250);
    window.addEventListener('load', sweep);
  })();

  /* ---------- Mobile drawer (focus trap + Esc) ---------- */
  (function drawer() {
    var btn = $('[data-menu-open]'), panel = $('#site-drawer'), overlay = $('[data-overlay]');
    if (!btn || !panel) return;
    var last = null;
    var focusables = 'a[href],button:not([disabled]),input,select,textarea,[tabindex]:not([tabindex="-1"])';

    function open() {
      last = document.activeElement;
      panel.dataset.open = 'true';
      panel.removeAttribute('inert');
      if (overlay) overlay.dataset.open = 'true';
      btn.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      var f = $$(focusables, panel);
      if (f.length) f[0].focus();
      document.addEventListener('keydown', onKey);
    }
    function close(leaving) {
      panel.dataset.open = 'false';
      // inert straight away would cancel the tapped link itself, so a link waits one tick
      if (leaving === true) setTimeout(function () { panel.setAttribute('inert', ''); }, 0);
      else panel.setAttribute('inert', '');
      if (overlay) overlay.dataset.open = 'false';
      btn.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      document.removeEventListener('keydown', onKey);
      if (leaving === true) return;           // a menu link was tapped: the page goes where the link says
      // fall back to the toggle if whatever had focus is gone or unfocusable. preventScroll: focusing the
      // button in the sticky header otherwise made phones jump back to the top of the page.
      var back = (last && last.isConnected && last.offsetParent !== null) ? last : btn;
      try { back.focus({ preventScroll: true }); } catch (err) { back.focus(); }
    }
    function onKey(e) {
      if (e.key === 'Escape') { close(); return; }
      if (e.key !== 'Tab') return;
      var f = $$(focusables, panel).filter(function (el) { return el.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], lastEl = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); lastEl.focus(); }
      else if (!e.shiftKey && document.activeElement === lastEl) { e.preventDefault(); first.focus(); }
    }
    panel.setAttribute('inert', '');          // closed on load
    btn.addEventListener('click', open);
    $$('[data-menu-close]').forEach(function (b) { b.addEventListener('click', close); });
    if (overlay) overlay.addEventListener('click', close);
    // Links in the menu close it straight away. "Shipping & returns" and "About" point to places on the
    // homepage, so on the homepage the page only scrolls, and the menu used to stay open over it.
    panel.addEventListener('click', function (e) {
      if (e.target.closest('a[href]') && panel.dataset.open === 'true') close(true);
    });
  })();

  /* ---------- Tabs (Spec Decoder) — WAI-ARIA tab pattern ---------- */
  $$('[data-tabs]').forEach(function (root) {
    var tabs = $$('[role="tab"]', root);
    var panels = $$('[role="tabpanel"]', root);
    if (!tabs.length) return;

    function select(i, setFocus) {
      tabs.forEach(function (t, n) {
        var on = n === i;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        if (on && setFocus) t.focus();
      });
      panels.forEach(function (p, n) { p.hidden = n !== i; });
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(i, false); });
      t.addEventListener('keydown', function (e) {
        var map = { ArrowRight: i + 1, ArrowLeft: i - 1, Home: 0, End: tabs.length - 1 };
        if (!(e.key in map)) return;
        e.preventDefault();
        var n = (map[e.key] + tabs.length) % tabs.length;
        select(n, true);
      });
    });
    select(0, false);
  });

  /* ---------- Hardness scale: tap a Chinese number, its ESN match lights up ---------- */
  $$('[data-scale]').forEach(function (scale) {
    var rows = $$('.scale__ticks', scale);
    var cn = $$('button', rows[0]);
    var esn = $$('.scale__tick', rows[1]);
    var out = $('[data-scale-out]', scale);
    cn.forEach(function (b, i) {
      b.addEventListener('click', function () {
        cn.forEach(function (x, n) {
          x.setAttribute('data-on', n === i ? 'true' : 'false');
          x.setAttribute('aria-pressed', n === i ? 'true' : 'false');
        });
        esn.forEach(function (x, n) { x.setAttribute('data-on', n === i ? 'true' : 'false'); });
        if (!reduced.matches) {
          esn[i].classList.remove('is-pop');
          void esn[i].offsetWidth;
          esn[i].classList.add('is-pop');
        }
        if (out) out.textContent = b.textContent + '° ≈ ' + esn[i].textContent + '° ESN';
      });
    });
  });

  /* ---------- Rubber picker (home): side, then level, then more spin or more speed, then two matches ----------
     All the steps and matches are in the page; this only shows one step at a time. Without JavaScript the
     picker stays hidden rather than half-working. */
  $$('[data-finder]').forEach(function (root) {
    var stages = $$('[data-finder-stage]', root);
    var side = null, sideText = '', level = null, levelText = '', timer = 0;

    function show(step, key) {
      root.setAttribute('data-step', String(step));
      stages.forEach(function (s) { s.hidden = s.getAttribute('data-finder-stage') !== String(step); });
      $$('[data-pick]', root).forEach(function (g) { g.hidden = g.getAttribute('data-pick') !== key; });
      $$('.finder__opt', root).forEach(function (b) { b.classList.remove('is-chosen'); });
      var q = $('[data-finder-stage="' + step + '"] .finder__q', root);
      if (q && root.classList.contains('is-live')) q.focus({ preventScroll: true });
    }

    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-finder-reset]')) {
        clearTimeout(timer); timer = 0; side = null; level = null;
        show(1);
        return;
      }
      var opt = e.target.closest('.finder__opt');
      if (!opt || timer) return;
      root.classList.add('is-live');
      opt.classList.add('is-chosen');
      function next() {
        timer = 0;
        if (opt.hasAttribute('data-side')) {
          side = opt.getAttribute('data-side');
          sideText = opt.textContent.trim();
          $$('[data-finder-summary]', root).forEach(function (el) { el.textContent = sideText; });
          show(2);
        } else if (opt.hasAttribute('data-level')) {
          level = opt.getAttribute('data-level');
          levelText = opt.textContent.trim();
          $$('[data-finder-summary]', root).forEach(function (el) { el.textContent = sideText + ' · ' + levelText; });
          show(3);
        } else {
          $$('[data-finder-summary]', root).forEach(function (el) {
            el.textContent = sideText + ' · ' + levelText + ' · ' + opt.textContent.trim();
          });
          show(4, side + '-' + level + '-' + opt.getAttribute('data-want'));
        }
      }
      // the chosen button stays dark for a moment, so the tap reads before the step changes
      if (reduced.matches) next(); else timer = setTimeout(next, 160);
    });

    show(1);
    root.hidden = false;
  });

  /* ---------- Accordion ---------- */
  $$('.acc__btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!open));
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      if (panel) panel.hidden = open;
    });
  });

  /* ---------- Cart (prototype only — no checkout) ---------- */
  function paintCart(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = String(count);
      el.hidden = count === 0;
    });
  }
  function announce(msg) {
    var live = $('#live-region');
    if (live) { live.textContent = ''; setTimeout(function () { live.textContent = msg; }, 60); }
  }

  /* ---------- Product pages ----------
     Scoped to each [data-pdp], so several product views can share one document (the
     bundled preview puts every page in a single file). Availability comes from the stock
     matrix printed into the page, per combination of options. */
  $$('[data-pdp]').forEach(function (pdp) {
    var S = strings(pdp);

    // quantity, capped at what is actually on the shelf
    var qtyIn = $('[data-qty] input', pdp);
    $$('[data-qty] button', pdp).forEach(function (b) {
      b.addEventListener('click', function () {
        var max = parseInt(qtyIn.max, 10) || 99;
        var n = (parseInt(qtyIn.value, 10) || 1) + (b.dataset.step === 'up' ? 1 : -1);
        qtyIn.value = Math.max(1, Math.min(max, n));
      });
    });

    // gallery: hand-taken photos only, letterboxed in a tone sampled from each photo
    var main = $('[data-gallery-main]', pdp);
    var frame = $('[data-gallery-frame]', pdp);
    var thumbs = $$('[data-gallery-thumb]', pdp);
    var resolveImg = window.__resolveGalleryImage || function (t) { return t.dataset.full; };
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        thumbs.forEach(function (x) { x.setAttribute('aria-current', 'false'); });
        t.setAttribute('aria-current', 'true');
        if (t.dataset.srcset) main.srcset = t.dataset.srcset; else main.removeAttribute('srcset');
        main.src = resolveImg(t);
        main.alt = t.dataset.alt || '';
        if (t.dataset.w) { main.width = +t.dataset.w; main.height = +t.dataset.h; }
        if (frame && t.dataset.bg) frame.style.setProperty('--backdrop', t.dataset.bg);
      });
    });

    // variants
    var box = $('[data-variants]', pdp);
    var matrixEl = $('[data-variant-matrix]', pdp);
    var matrix = [];
    try { matrix = JSON.parse(matrixEl ? matrixEl.textContent : '[]'); } catch (e) { matrix = []; }
    var groups = box ? $$('[data-optgroup]:not([data-static])', box) : [];
    var names = groups.map(function (g) { return g.dataset.optgroup; });
    var addBtn = $('[data-add]', pdp);
    var idInput = $('[data-variant-id]', pdp);
    var buyForm = $('[data-product-form]', pdp);
    var stockText = $('[data-stock-text]', pdp);
    var state = {};

    groups.forEach(function (g) {
      var on = $('.swatch[aria-pressed="true"]', g) || $('.swatch', g);
      if (on) state[g.dataset.optgroup] = on.dataset.value;
    });

    function agrees(v, upto) {
      for (var i = 0; i < upto; i++) if (v[names[i]] !== state[names[i]]) return false;
      return true;
    }
    function current() {
      return matrix.filter(function (v) { return agrees(v, names.length); })[0] || null;
    }
    // After a choice in group k, give every later group a value that exists alongside the
    // earlier choices, preferring one in stock. Earlier groups are never hidden on
    // combination grounds, so every variant stays reachable.
    function settle(from) {
      for (var i = from; i < names.length; i++) {
        var fits = matrix.filter(function (v) { return agrees(v, i); });
        var keep = fits.some(function (v) { return v[names[i]] === state[names[i]] && v.stock > 0; });
        if (!keep && fits.length) {
          fits.sort(function (a, b) { return (b.stock > 0) - (a.stock > 0); });
          state[names[i]] = fits[0][names[i]];
        }
      }
    }
    function render() {
      // specs tied to one choice (a combined listing's hardness and colour per model)
      $$('[data-when]', pdp).forEach(function (el) {
        var kv = el.dataset.when.split(':');
        el.hidden = state[kv[0]] !== kv[1];
      });
      groups.forEach(function (g, i) {
        $$('.swatch', g).forEach(function (b) {
          var val = b.dataset.value;
          var pool = matrix.filter(function (v) { return agrees(v, i) && v[names[i]] === val; });
          var soldOut = pool.length > 0 && pool.every(function (v) { return v.stock <= 0; });
          b.hidden = pool.length === 0;             // this combination is not made
          b.disabled = soldOut;
          b.setAttribute('aria-pressed', String(state[names[i]] === val));
          var name = b.dataset.name || b.textContent;
          b.setAttribute('aria-label', soldOut ? name + ', ' + S.soldOut.toLowerCase() : name);
        });
      });
      var v = current();
      var n = v ? v.stock : 0;
      if (idInput && v && v.id) idInput.value = v.id;
      if (addBtn && !addBtn.dataset.busy) {
        addBtn.disabled = n <= 0;
        addBtn.textContent = n <= 0 ? S.soldOut : S.addToCart;
      }
      if (qtyIn) {
        qtyIn.max = String(Math.max(1, n));
        if ((parseInt(qtyIn.value, 10) || 1) > Math.max(1, n)) qtyIn.value = Math.max(1, n);
      }
      if (stockText) {
        var anyIn = matrix.some(function (x) { return x.stock > 0; });
        // a page may carry the dispatch details in their own [data-stock-more] elements
        var more = $$('[data-stock-more]', pdp);
        stockText.textContent = n <= 0
          ? (anyIn ? S.optionOut : S.allOut)
          : (n === 1 ? S.only1 : S.inStock) + (more.length ? '' : S.dispatch);
        more.forEach(function (el) { el.hidden = n <= 0; });
      }
    }

    groups.forEach(function (g, i) {
      $$('.swatch', g).forEach(function (b) {
        b.addEventListener('click', function () {
          if (b.disabled) return;
          state[names[i]] = b.dataset.value;
          settle(i + 1);
          render();
          // photos tied to a choice follow it: pick a model, see that model's packaging
          var target = $$('[data-gallery-thumb][data-photo-for]', pdp).filter(function (t) {
            var kv = t.dataset.photoFor.split(':');
            return state[kv[0]] === kv[1];
          })[0];
          var active = $('[data-gallery-thumb][aria-current="true"]', pdp);
          if (target && (!active || active.dataset.photoFor !== target.dataset.photoFor)) target.click();
        });
      });
    });

    var start = current();
    if (!start || start.stock <= 0) {
      var firstIn = matrix.filter(function (x) { return x.stock > 0; })[0];
      if (firstIn) names.forEach(function (nm) { state[nm] = firstIn[nm]; });
    }
    settle(0);
    render();

    if (buyForm && addBtn) {
      buyForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var v = current();
        if (addBtn.disabled || !v) return;
        var max = qtyIn ? (parseInt(qtyIn.max, 10) || 99) : 99;
        var n = qtyIn ? Math.max(1, Math.min(max, parseInt(qtyIn.value, 10) || 1)) : 1;
        if (qtyIn) qtyIn.value = n;
        addBtn.dataset.busy = '1';
        addBtn.disabled = true;
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        var json = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
        fetch(root + 'cart/add.js', { method: 'POST', headers: json, body: JSON.stringify({ items: [{ id: v.id, quantity: n }] }) })
          .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
          .then(function () { return fetch(root + 'cart.js', { headers: json }).then(function (r) { return r.json(); }); })
          .then(function (c) {
            paintCart(c.item_count);
            addBtn.textContent = S.added;
            var link = $('[data-cart-link]', pdp);
            if (link) link.hidden = false;
            var chosen = names.map(function (nm) { return state[nm]; }).join(', ');
            announce(n + ' \u00d7 ' + (addBtn.dataset.add || S.item) + (chosen ? ' (' + chosen + ')' : '') +
                     S.addedToCart + c.item_count + (c.item_count === 1 ? S.oneItem : S.items));
          })
          .catch(function (err) {
            var msg = (err && (err.description || err.message)) || S.cartError;
            if (stockText) stockText.textContent = msg;
            announce(msg);
          })
          .then(function () { setTimeout(function () { delete addBtn.dataset.busy; render(); }, 1400); });
      });
    }
  });

  /* ---------- Collection: filters + sort ----------
     Everything is looked up inside the catalogue's own page (the document, or a preview route),
     so two catalogues in one document never drive each other. */
  $$('[data-grid]').forEach(function (grid) {
    var root = grid.closest('.route') || document;
    var S = strings(grid);
    var cards = $$('[data-product]', grid);
    var countEl = $('[data-result-count]', root);
    var empty = $('[data-empty]', root);
    var sort = $('[data-sort]', root);
    var toggle = $('[data-filter-toggle]', root);
    var panel = $('[data-filters]', root);

    if (toggle && panel) {
      // Below 64rem the filters are a panel that slides in from the side (the store theme styles it that way;
      // the prototype still opens them above the grid). Wide screens show them as a sidebar and skip all this.
      var narrow = window.matchMedia ? window.matchMedia('(max-width: 63.99rem)') : { matches: false };
      var shade = $('[data-filters-overlay]', root);
      var lastFocus = null;
      var setOpen = function (on) {
        panel.dataset.open = String(on);
        toggle.setAttribute('aria-expanded', String(on));
        if (!narrow.matches || !shade) return;
        shade.dataset.open = String(on);
        document.body.style.overflow = on ? 'hidden' : '';
        if (on) {
          lastFocus = document.activeElement;
          panel.removeAttribute('inert');
          var x = $('[data-filters-close]', panel);
          if (x) x.focus();
        } else {
          panel.setAttribute('inert', '');
          if (lastFocus && lastFocus.focus) lastFocus.focus();
        }
      };
      var fit = function () {
        if (!shade) return;
        if (narrow.matches) {
          if (panel.dataset.open !== 'true') panel.setAttribute('inert', '');
        } else {
          panel.removeAttribute('inert');
          shade.dataset.open = 'false';
          document.body.style.overflow = '';
        }
      };
      fit();
      if (narrow.addEventListener) narrow.addEventListener('change', fit);
      toggle.addEventListener('click', function () { setOpen(panel.dataset.open !== 'true'); });
      $$('[data-filters-close]', root).forEach(function (b) { b.addEventListener('click', function () { setOpen(false); }); });
      if (shade) shade.addEventListener('click', function () { setOpen(false); });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && panel.dataset.open === 'true' && narrow.matches) setOpen(false);
      });
    }

    function activeBy(group) {
      return $$('input[data-facet="' + group + '"]:checked', root).map(function (i) { return i.value; });
    }

    function apply() {
      var facets = ['type', 'brand', 'character', 'hardness'];
      var sel = {};
      facets.forEach(function (f) { sel[f] = activeBy(f); });

      var shown = 0;
      cards.forEach(function (card) {
        var ok = facets.every(function (f) {
          if (!sel[f].length) return true;
          var vals = (card.dataset[f] || '').split(' ');
          return sel[f].some(function (v) { return vals.indexOf(v) > -1; });
        });
        card.hidden = !ok;
        if (ok) shown++;
      });

      if (countEl) countEl.textContent = S.count(shown);
      var drawerCount = $('[data-filters-n]', root);    // the number on "Show products (n)"
      if (drawerCount) drawerCount.textContent = shown;
      if (empty) empty.hidden = shown > 0;
      announce(S.matchFilters(shown));
    }

    $$('input[data-facet]', root).forEach(function (i) { i.addEventListener('change', apply); });

    var clear = $('[data-clear-filters]', root);
    if (clear) {
      clear.addEventListener('click', function () {
        $$('input[data-facet]', root).forEach(function (i) { i.checked = false; });
        apply();
      });
    }

    if (sort) {
      sort.addEventListener('change', function () {
        var mode = sort.value;
        var sorted = cards.slice().sort(function (a, b) {
          if (mode === 'price-asc') return (+a.dataset.price) - (+b.dataset.price);
          if (mode === 'price-desc') return (+b.dataset.price) - (+a.dataset.price);
          if (mode === 'hard-asc') return (+a.dataset.deg) - (+b.dataset.deg);
          if (mode === 'hard-desc') return (+b.dataset.deg) - (+a.dataset.deg);
          return (+a.dataset.rank) - (+b.dataset.rank);
        });
        sorted.forEach(function (c) { grid.appendChild(c); });
        announce(S.sortedBy(sort.options[sort.selectedIndex].text));
      });
    }

    apply();
  });

  /* ---------- Dropdown: branded listbox over a native <select> ----------
     The open list of a native <select> is drawn by the operating system and cannot take the
     site's colours, so it is rebuilt as an ARIA listbox. The <select> stays in the page as the
     source of truth: every choice is written back to it and fires its own "change" event, so
     sorting, tests and the no-JS fallback all keep working. */
  var dropCount = 0;
  $$('select.select').forEach(function (sel) {
    var id = 'dd' + (++dropCount);
    var label = sel.id ? $('label[for="' + sel.id + '"]') : null;
    if (label && !label.id) label.id = id + '-label';

    var wrap = document.createElement('div');
    wrap.className = 'dropdown';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'select dropdown__btn';
    btn.id = id + '-btn';
    btn.setAttribute('aria-haspopup', 'listbox');
    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('aria-controls', id + '-list');
    if (label) btn.setAttribute('aria-labelledby', label.id + ' ' + btn.id);
    var list = document.createElement('ul');
    list.className = 'dropdown__list';
    list.id = id + '-list';
    list.setAttribute('role', 'listbox');
    list.tabIndex = -1;
    if (label) list.setAttribute('aria-labelledby', label.id);
    list.hidden = true;

    var opts = [].slice.call(sel.options).map(function (o, i) {
      var li = document.createElement('li');
      li.id = id + '-o' + i;
      li.setAttribute('role', 'option');
      li.className = 'dropdown__opt';
      li.textContent = o.textContent;
      li.dataset.value = o.value;
      list.appendChild(li);
      return li;
    });

    sel.parentNode.insertBefore(wrap, sel);
    wrap.appendChild(sel);
    wrap.appendChild(btn);
    wrap.appendChild(list);
    sel.hidden = true;
    sel.tabIndex = -1;
    if (label) label.addEventListener('click', function (e) { e.preventDefault(); btn.focus(); });

    var active = 0;
    function sync() {
      var i = Math.max(0, sel.selectedIndex);
      btn.textContent = sel.options[i].textContent;
      opts.forEach(function (li, n) { li.setAttribute('aria-selected', n === i ? 'true' : 'false'); });
      btn.toggleAttribute('data-default', sel.selectedIndex === 0);
    }
    function mark(i) {
      active = (i + opts.length) % opts.length;
      opts.forEach(function (li, n) { li.classList.toggle('is-active', n === active); });
      list.setAttribute('aria-activedescendant', opts[active].id);
      opts[active].scrollIntoView({ block: 'nearest' });
    }
    function open() {
      list.hidden = false;
      wrap.classList.add('is-open');
      btn.setAttribute('aria-expanded', 'true');
      mark(Math.max(0, sel.selectedIndex));
      list.focus();
      document.addEventListener('pointerdown', outside, true);
    }
    function close(refocus) {
      list.hidden = true;
      wrap.classList.remove('is-open');
      btn.setAttribute('aria-expanded', 'false');
      document.removeEventListener('pointerdown', outside, true);
      if (refocus) btn.focus();
    }
    function choose(i) {
      if (sel.selectedIndex !== i) {
        sel.selectedIndex = i;
        sel.dispatchEvent(new Event('change', { bubbles: true }));
      }
      sync();
      close(true);
    }
    function outside(e) { if (!wrap.contains(e.target)) close(false); }

    btn.addEventListener('click', function () { if (list.hidden) open(); else close(true); });
    btn.addEventListener('keydown', function (e) {
      if (['ArrowDown', 'ArrowUp', 'Enter', ' '].indexOf(e.key) > -1) { e.preventDefault(); open(); }
    });
    list.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') { e.preventDefault(); mark(active + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); mark(active - 1); }
      else if (e.key === 'Home') { e.preventDefault(); mark(0); }
      else if (e.key === 'End') { e.preventDefault(); mark(opts.length - 1); }
      else if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); choose(active); }
      else if (e.key === 'Escape') { e.preventDefault(); close(true); }
      else if (e.key === 'Tab') { close(false); }
    });
    opts.forEach(function (li, n) {
      li.addEventListener('pointermove', function () { if (n !== active) mark(n); });
      li.addEventListener('click', function () { choose(n); });
    });
    sel.addEventListener('change', sync);   // changed from code (tests, filters reset)
    sync();
  });

  /* ---------- Guide: scrollspy ----------
     Resolves targets by id rather than by selector: in the bundled preview the
     href is a route ("#/guide") and the real target lives in data-anchor, and
     querySelector would throw on that. Scroll-driven so it does not depend on
     an observer firing. */
  (function spy() {
    var links = $$('[data-spy] a');
    if (!links.length) return;
    var targets = links.map(function (a) {
      var id = a.dataset.anchor || (a.getAttribute('href') || '').replace(/^#/, '');
      return id ? document.getElementById(id) : null;
    });
    if (!targets.some(Boolean)) return;

    function mark() {
      var line = (window.innerHeight || 800) * 0.3;
      var best = -1, bestTop = -Infinity;
      targets.forEach(function (s, i) {
        if (!s) return;
        var top = s.getBoundingClientRect().top;
        if (top <= line && top > bestTop) { bestTop = top; best = i; }
      });
      if (best < 0) best = 0;
      links.forEach(function (a, i) {
        if (i === best) a.setAttribute('aria-current', 'true');
        else a.removeAttribute('aria-current');
      });
    }

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      setTimeout(function () { ticking = false; mark(); }, 100);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    mark();
    setTimeout(mark, 300);
    window.addEventListener('load', mark);
  })();

  /* ---------- Copy a code ([data-copy], e.g. the launch offer) ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-copy]');
    if (!b) return;
    var state = $('[data-copy-state]', b);
    var done = function () {
      if (!state) return;
      state.textContent = state.dataset.done;
      setTimeout(function () { state.textContent = state.dataset.idle; }, 1800);
    };
    // older browsers: copy through a hidden text field
    var fallback = function () {
      var t = document.createElement('textarea');
      t.value = b.dataset.copy; t.setAttribute('readonly', ''); t.style.position = 'fixed'; t.style.opacity = '0';
      document.body.appendChild(t); t.select();
      try { document.execCommand('copy'); } catch (err) { /* nothing more to try */ }
      t.remove(); done();
    };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(b.dataset.copy).then(done, fallback);
    else fallback();
  });

  /* ---------- Reviews: our translation or the original ([data-review-swap], snippet review-card) ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-review-swap]');
    if (!b) return;
    var card = b.closest('.review');
    var original = $('[data-review-text="original"]', card);
    var toOriginal = original.hidden;
    original.hidden = !toOriginal;
    $('[data-review-text="translation"]', card).hidden = toOriginal;
    $('[data-review-note]', card).hidden = toOriginal;
    b.textContent = toOriginal ? b.dataset.translation : b.dataset.original;
  });

  /* ---------- Page transition ----------
     Fade the current page out before following an internal link, so arriving
     on the next page continues the motion instead of cutting to it. */
  (function pageTransition() {
    if (reduced.matches) return;
    var LEAVE = 180;
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[href]');
      if (!a) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
      if (a.target && a.target !== '_self') return;
      var href = a.getAttribute('href');
      if (!href || href.charAt(0) === '#' || /^(mailto:|tel:|https?:)/.test(href)) return;
      var url = new URL(a.href, location.href);
      if (url.origin !== location.origin) return;
      // same page, different anchor: let the browser scroll, don't fade
      if (url.pathname === location.pathname) return;
      e.preventDefault();
      document.documentElement.setAttribute('data-leaving', '');
      setTimeout(function () { location.href = a.href; }, LEAVE);
    });
    // restore on back/forward out of the bfcache
    window.addEventListener('pageshow', function () {
      document.documentElement.removeAttribute('data-leaving');
    });
  })();

})();
